import React, { Fragment } from 'react';
import { Button } from './Button';
import { Typography } from './Typography';
import { ArrowDownIcon, InfoIcon } from 'lucide-react';
import { t } from '../src/locales';
export const HeroSection = () => {
  return <section className="w-full bg-[#EBE6DC] py-20 px-6 md:px-12" data-id="element-82">
      <div className="max-w-6xl mx-auto" data-id="element-83">
        <div className="flex flex-col md:flex-row items-center" data-id="element-84">
          <div className="md:w-1/2 mb-10 md:mb-0" data-id="element-85">
            <h1 className="text-[50px] leading-[56px] text-[#192636] font-[200] mb-6" data-id="element-86">
              {t('hero.title').split('\n').map((line, i) => <Fragment key={i} data-id="element-87">
                    {line}
                    {i < t('hero.title').split('\n').length - 1 && <br data-id="element-88" />}
                  </Fragment>)}
            </h1>
            <Typography variant="medium" className="text-[#192636] mb-8 max-w-lg" data-id="element-89">
              {t('hero.description')}
            </Typography>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-90">
              <Button data-id="element-91">{t('hero.tryButton')}</Button>
              <Button variant="secondary" icon={InfoIcon} data-id="element-92">
                {t('hero.learnMoreButton')}
              </Button>
            </div>
          </div>
          <div className="md:w-1/2 flex justify-center" data-id="element-93">
            <img src="https://sleep.moonbird.life/lovable-uploads/f3f28346-3899-4628-8186-34dca7982a8d.png" alt="moonbird breathing device" className="rounded-xl max-w-full h-auto shadow-lg" data-id="element-94" />
          </div>
        </div>
        <div className="flex justify-center mt-16" data-id="element-95">
          <a href="#benefits" className="flex flex-col items-center text-[#192636] hover:text-[#004FFF] transition-colors" data-id="element-96">
            <Typography variant="small" data-id="element-97">{t('hero.discoverMore')}</Typography>
            <ArrowDownIcon className="mt-2 animate-bounce" data-id="element-98" />
          </a>
        </div>
      </div>
    </section>;
};